/**
 * App Feedback Service — Matches Xamarin FeedbackService.cs
 *
 * Handles posting user feedback/suggestions to the admin API.
 */

import { Endpoints } from '@/constants';
import { ymsAdminClient } from '@/service/taskService';

import type { FeedbackRequestDTO, FeedbackResponseDTO } from '@/types';

// Matches Xamarin FeedbackService.PostSuggestion():
// "suggestions?code={functionCode}"
export async function postSuggestion(
  request: FeedbackRequestDTO,
  functionCode: string
): Promise<FeedbackResponseDTO> {
  if (!/^[a-zA-Z0-9_=-]+$/.test(functionCode)) {
    throw new Error('Invalid function code');
  }

  const response = await ymsAdminClient.post<FeedbackResponseDTO>(
    `${Endpoints.Suggestions}${functionCode}`,
    request
  );
  return response.data;
}

export const appFeedbackApi = {
  postSuggestion,
};
